import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/ctaSection/ctaSection";
import shape1 from "../../images/team/shape6.png";
import shape2 from "../../images/progress-shape-1.png";
import shape3 from "../../images/progress-shape-2.png";
import axios from "axios";
import { SiTiktok } from "react-icons/si";
import { FaLinkedin, FaTelegramPlane } from "react-icons/fa";
import Navbar2 from "../../components/Navbar2/Navbar2";
import img from "../../images/contact.jpg";
import StarLoader from "../../components/loader/StarLoader";

const TeamSinglePage = () => {
  const { id } = useParams();
  const [teamMember, setTeamMember] = useState(null);
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    const fetchTeamMember = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/teams-list/${id}`);
        setTeamMember(response.data);
      } catch (error) {
        console.error("Error fetching team member:", error);
      } finally {
        // ✅ Stop loader as soon as fetch finishes
        setLoading(false);
      }
    };

    fetchTeamMember();
  }, [id, apiUrl]);

  // 👇 Show loader while loading is true, else show the full page
  if (loading || !teamMember) {
    return <StarLoader />;
  }

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle
        pageTitle={teamMember.full_name}
        pagesub={teamMember.title}
        img={img}
      />

      <div
        className="team-pg-area"
        style={{
          backgroundColor: "#f9fbff",
        }}
      >
        <div
          className="team-inner section-padding"
          style={{
            backgroundColor: "#E6F7FF",
            paddingTop: "70px", // reduce vertical padding
            paddingBottom: "70px", // reduce vertical padding
          }}
        >
          <div className="container">
            <div className="team-info-wrap">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div
                    className="team-info-img"
                    style={{
                      position: "relative",
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 8px 25px rgba(0, 51, 102, 0.25)",
                    }}
                  >
                    <img
                      src={`${apiUrl}/storage/` + teamMember.image}
                      alt={teamMember.full_name}
                      style={{
                        width: "100%",
                        height: "400px",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      className="shape"
                      style={{ position: "absolute", bottom: 0, right: 0 }}
                    >
                      <img src={shape1} alt="shape" />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div
                    className="team-info-text"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "30px",
                      boxShadow: "0 4px 15px rgba(0, 0, 80, 0.1)",
                    }}
                  >
                    <h2 style={{ color: "#002B5B", marginBottom: "10px" }}>
                      {teamMember.full_name}
                    </h2>
                    <span
                      style={{
                        display: "inline-block",
                        color: "#0056b3",
                        fontWeight: "500",
                        marginBottom: "15px",
                      }}
                    >
                      {teamMember.position}
                    </span>

                    <div style={{ color: "#333", lineHeight: "1.7" }}>
                      <p>
                        <strong>Email:</strong> {teamMember.email}
                      </p>
                      <p>
                        <strong>Phone 1:</strong> {teamMember.phone1}
                      </p>
                      {teamMember.phone2 && (
                        <p>
                          <strong>Phone 2:</strong> {teamMember.phone2}
                        </p>
                      )}
                      {teamMember.address && (
                        <p>
                          <strong>Address:</strong> {teamMember.address}
                        </p>
                      )}
                    </div>

                    {(teamMember.facebookLink ||
                      teamMember.instagramLink ||
                      teamMember.tiktokLink ||
                      teamMember.twitterLink ||
                      teamMember.linkedInLink ||
                      teamMember.telegramLink) && (
                      <h3
                        style={{
                          marginTop: "30px",
                          marginBottom: "15px",
                          color: "#002B5B",
                          fontWeight: "600",
                          borderBottom: "2px solid #007bff",
                          display: "inline-block",
                          paddingBottom: "5px",
                        }}
                      >
                        Contact With
                      </h3>
                    )}

                    <ul
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "15px",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      {teamMember.facebookLink && (
                        <li>
                          <a
                            href={teamMember.facebookLink}
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                hoveredIcon === "facebook" ? "#fff" : "#002B5B",
                              backgroundColor:
                                hoveredIcon === "facebook"
                                  ? "#007bff"
                                  : "transparent",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={() => setHoveredIcon("facebook")}
                            onMouseLeave={() => setHoveredIcon(null)}
                          >
                            <i className="ti-facebook"></i>
                          </a>
                        </li>
                      )}

                      {teamMember.twitterLink && (
                        <li>
                          <a
                            href={teamMember.twitterLink}
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                hoveredIcon === "twitter" ? "#fff" : "#002B5B",
                              backgroundColor:
                                hoveredIcon === "twitter"
                                  ? "#1DA1F2"
                                  : "transparent",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={() => setHoveredIcon("twitter")}
                            onMouseLeave={() => setHoveredIcon(null)}
                          >
                            <i className="ti-twitter-alt"></i>
                          </a>
                        </li>
                      )}

                      {teamMember.instagramLink && (
                        <li>
                          <a
                            href={teamMember.instagramLink}
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                hoveredIcon === "instagram"
                                  ? "#fff"
                                  : "#002B5B",
                              backgroundColor:
                                hoveredIcon === "instagram"
                                  ? "#E4405F"
                                  : "transparent",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={() => setHoveredIcon("instagram")}
                            onMouseLeave={() => setHoveredIcon(null)}
                          >
                            <i className="ti-instagram"></i>
                          </a>
                        </li>
                      )}

                      {teamMember.tiktokLink && (
                        <li>
                          <a
                            href={teamMember.tiktokLink}
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                hoveredIcon === "tiktok" ? "#fff" : "#002B5B",
                              backgroundColor:
                                hoveredIcon === "tiktok"
                                  ? "#010101"
                                  : "transparent",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={() => setHoveredIcon("tiktok")}
                            onMouseLeave={() => setHoveredIcon(null)}
                          >
                            <SiTiktok />
                          </a>
                        </li>
                      )}

                      {teamMember.telegramLink && (
                        <li>
                          <a
                            href={teamMember.telegramLink}
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                hoveredIcon === "telegram" ? "#fff" : "#002B5B",
                              backgroundColor:
                                hoveredIcon === "telegram"
                                  ? "#0088cc"
                                  : "transparent",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={() => setHoveredIcon("telegram")}
                            onMouseLeave={() => setHoveredIcon(null)}
                          >
                            <FaTelegramPlane />
                          </a>
                        </li>
                      )}

                      {teamMember.linkedInLink && (
                        <li>
                          <a
                            href={teamMember.linkedInLink}
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                hoveredIcon === "linkedin" ? "#fff" : "#002B5B",
                              backgroundColor:
                                hoveredIcon === "linkedin"
                                  ? "#0A66C2"
                                  : "transparent",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={() => setHoveredIcon("linkedin")}
                            onMouseLeave={() => setHoveredIcon(null)}
                          >
                            <FaLinkedin />
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pr-shape-1">
            <img src={shape2} alt="" />
          </div>
          <div className="pr-shape-2">
            <img src={shape3} alt="" />
          </div>
        </div>
      </div>

      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default TeamSinglePage;
